/**
 * radius
 * @param values
 */
export function radius(name) {
    return function (_a) {
        var theme = _a.theme;
        return theme.radius[name];
    };
}
